import React from 'react';
import PropTypes from 'prop-types';
import GeneralInformation from './sections/general-information';
import RentAndEscalations from './sections/rent-and-escalations';
import Expenses from './sections/expenses';
import { getVoucherAccordionStorageKey } from '../file-upload-accordian';

const LeaseComp = ({ dealId, onGeneralInformationExpand }) => (
  <>
    <GeneralInformation onExpand={onGeneralInformationExpand} storageKey={getVoucherAccordionStorageKey(dealId, 'leaseComp', 'generalInformation')} />
    <RentAndEscalations storageKey={getVoucherAccordionStorageKey(dealId, 'leaseComp', 'rentAndEscalations')} />
    <Expenses storageKey={getVoucherAccordionStorageKey(dealId, 'leaseComp', 'expenses')} />
  </>
);

LeaseComp.propTypes = {
  dealId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onGeneralInformationExpand: PropTypes.func,
};

LeaseComp.defaultProps = {
  dealId: '',
  onGeneralInformationExpand: () => {},
};

export default LeaseComp;
